import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { LayoutConfigService } from '../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { UserService } from '../../../../core/user/_services/user.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';


@Component({
  selector: 'app-full-welcome-dialog',
  templateUrl: './full-welcome.dialog.component.html',
  styleUrls: ['./full-welcome.dialog.component.scss']
})
export class FullWelcomeDialogComponent implements OnInit, AfterViewInit {
  loading: boolean;
  fetchingData: boolean = true;
  supportNumber: string;
  countryNumber: string;
  supportEmail: string;
  siteName: string;
  logo: string;
  homepageNotice: string;
  bannerTitle: string;
  bannerSubtitle: string;
  terms: boolean = true;
  userInfoForm: FormGroup;
  partners: string[];
  operators: any[];

  constructor(
    public dialogRef: MatDialogRef<FullWelcomeDialogComponent>,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private cookieService: CookieService,
    private layoutUtilsService: LayoutUtilsService,
    private layoutConfigService: LayoutConfigService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.countryNumber = `+${this.layoutConfigService.getConfig('site.countryNumber')}`;
    this.userInfoForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: [this.countryNumber, [Validators.required, , Validators.pattern('^\\+?([0-9 ]{2,5})\\)?[-]?([0-9 ]{4})[-]?([0-9 ]{4,7})$')]]
    });
    this.operators = data.operators;
  }

  ngOnInit(): void {
    // const config = this.layoutConfigService.getConfig();
    this.supportNumber = this.layoutConfigService.getConfig('site.supportNumber');
    this.supportEmail = this.layoutConfigService.getConfig('site.supportEmail');
    this.siteName = this.layoutConfigService.getConfig('site.name');
    this.logo = this.layoutConfigService.getConfig('self.logoLight');
    this.homepageNotice = this.layoutConfigService.getConfig('site.homepageNotice');
    this.bannerTitle = this.layoutConfigService.getConfig('texts.bannerTitle');
    this.bannerSubtitle = this.layoutConfigService.getConfig('texts.bannerSubtitle');
    this.partners = this.layoutConfigService.getConfig('partners');

    this.cookieService.delete('booking_details');

  
  }

  closeDialog() {
    this.dialogRef.close({event: 'cancel'});
  }

  toggleTerms() {
    this.terms = !this.terms;
  }

  setDefaultPic() {
    
    this.cdr.detectChanges();
  }

  onSubmit() {
    if (this.userInfoForm.invalid) {
      this.userInfoForm.markAllAsTouched();
      return;
    }
    if (!this.terms) {
      this.layoutUtilsService.showActionNotification('Please agree to receive discounts and promotions', MessageType.Read, 3000);
      return;
    }
    this.loading = true;
    let phoneNumber = this.userInfoForm.controls.phone.value;
    if (phoneNumber[0] !== "+") {
      phoneNumber = phoneNumber.replace(phoneNumber[0], this.countryNumber);
      this.userInfoForm.patchValue({
        phone: phoneNumber
      })
    }

    const userInfo = {
      firstName: this.userInfoForm.controls.firstName.value,
      lastName: this.userInfoForm.controls.lastName.value,
      phone: this.userInfoForm.controls.phone.value.replace(/ /g, '')
    };
    const visitor = {
      ...userInfo,
      // appName: this.siteName,
      referrer: this.data.referrer,
      url: this.data.url,
      userAgent: this.data.userAgent
    }
    this.userService.saveVisitor(visitor).pipe(tap(response => {
      this.loading = false;
      if (response.success) {
        const payload = {...userInfo, acceptTerms: this.terms};
        this.dialogRef.close({event: 'submit', payload});
      } else {
        this.layoutUtilsService.showActionNotification('Error saving data, please try again', MessageType.Read);
      }
    }), catchError(err => {
      this.loading = false;
      this.layoutUtilsService.showActionNotification(err.error.message[0] || 'Error saving data', MessageType.Read);
      return of(err);
    })).subscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.fetchingData = false;
    }, 2000);
  }

}
